import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { pluralReadableTypeName } from '@iotv/core-services';
import { isEdgeParams } from '@iotv/iotv-v3-types';
import { Typography } from '@mui/material';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContainerArbitrator } from '../../../../ArbitrationObjects/ContainerArbitrator/containerArbitrator';
import { NavSections } from '../../../../components/navigation/NavSections';
import { AppMainViewContext } from '../../../../ContextProviders/AppContextProvider';
import { ExtendedTreeItem } from './ExtendedTreeItemV3';
const debug = process.env.REACT_APP_DEBUG && false;
/** returns a LabelClickWrapper with the URL determined by a fn */
export const DestinationConfigurabaleLabelClickWrapper = ({ vob, vobToUrlFn, element }) => {
    const navigate = useNavigate();
    return (_jsx("span", { style: { flexGrow: 1 }, onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
            const url = vobToUrlFn(vob);
            debug && console.log(`(basicAdminViewOnLabelClick) DestinationConfigurabaleLabelClickWrapper onclick has url ${url} `, vob);
            navigate(url);
        }, children: element }));
};
/** return a function that can be useed in trees as LabelClickWrapper, with the desitnation determined by the input fn ( which itself takes a VOB and returns an URL) */
export const DestinationConfigurabaleLabelClickWrapperFn = (vobToUrlFn) => ({ vob, element }) => (_jsx(DestinationConfigurabaleLabelClickWrapper, { vobToUrlFn, vob, element }));
export const basicAdminViewOnLabelClick = DestinationConfigurabaleLabelClickWrapperFn((vob) => {
    /** 2024 11 RSE having to debug stuff that should have been sorted, again. This does not fire on DeviceGroups -> Device */
    debug && console.log(`basicAdminViewOnLabelClick injected fn is called with `, vob);
    const link = ContainerArbitrator.getCanonicalContainerLinkForObject({ vob });
    return link;
});
export const DefaultLabelClickWrapper = ({ vob, element }) => {
    let containerRoots = {};
    const [{ thingViewMap }] = useContext(AppMainViewContext);
    if (thingViewMap) {
        containerRoots = { [NavSections.THINGVIEW]: Object.keys(thingViewMap) };
    }
    const vobToUrlFn = (vob) => ContainerArbitrator.getCanonicalContainerLinkForObject({ vob, containerRoots });
    return _jsx(DestinationConfigurabaleLabelClickWrapper, { vob, vobToUrlFn, element });
};
export const DefaultStepTypeFolderClickWrapper = ({ sourceObject, objectTypeId, element, support }) => {
    const navigate = useNavigate();
    debug && console.log('DefaultStepTypeFolderClickWrapper', { sourceNode: sourceObject, objectTypeId });
    return (_jsx("span", { style: { flexGrow: 1 }, onClick: (e) => {
            e.stopPropagation();
            debug && console.log('DefaultStepTypeFolderClickWrapper', { sourceObject, objectTypeId });
            if (objectTypeId === 'Group') {
                navigate(`/${NavSections.THINGSVIEW}/${objectTypeId}${sourceObject ? `?contextObjectSk=${sourceObject.sk}&sub=${support}` : ''}`);
            }
            else {
                navigate(`/${NavSections.THINGSVIEW}/${objectTypeId}${sourceObject ? `?contextObjectSk=${sourceObject.sk}` : ''}`);
            }
        }, children: element }));
};
/**
 * Renders a grouping folder by type and passes through the child treeItems
 */
export const TypeTreeFolder = ({ queryPath, sourceObject, children, LastEvaluatedKey, keyPrefix, onTypeFolderClickWrapper }) => {
    const { stepQuery } = queryPath;
    let element = null;
    if (isEdgeParams(stepQuery)) {
        const objectTypeId = stepQuery.objectTypeId;
        const labelText = pluralReadableTypeName(objectTypeId);
        element = (_jsx(ExtendedTreeItem, { keyIn: `${keyPrefix}_${objectTypeId}`,
            label: onTypeFolderClickWrapper ? (onTypeFolderClickWrapper({ sourceObject, objectTypeId, element: _jsx(Typography, { flexGrow: 1, children: labelText }) })) : (_jsx(Typography, { flexGrow: 1, children: labelText })),
            x: _jsx(_Fragment, {}),
            children }));
    }
    else {
        console.log(`WARN: not rendering type folder on a curriedStepQuery`);
    }
    debug && console.log(`rendering type folder with `, { sourceObject, wrapper: onTypeFolderClickWrapper?.name });
    return element;
};
